import { render, staticRenderFns } from "./SelectTipoSolicitud.vue?vue&type=template&id=2e04b579&"
import script from "./SelectTipoSolicitud.vue?vue&type=script&lang=js&"
export * from "./SelectTipoSolicitud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
